import EventEmitter from '../EventEmitter';

export default class SpeechProviderInterface extends EventEmitter {
    constructor() {
        super();
        this.providerName = this.constructor.name;
        this.status = 'unknown';
    }

    async start() {
        throw new Error(`start() must be implemented in ${this.providerName}`);
    }

    stop() {
        throw new Error(`stop() must be implemented in ${this.providerName}`);
    }
}
